export const FRIENDLY_LABELS_NAME = "friendly_labels"

export enum FRIENDLY_LABELS {
    FEM = "fem",
    FRIENDLY = "friendly",
    BELIEVER = "believer",
    CANCER = "cancer",
}
